import * as types from "../actions/actionTypes";

// A toast: the message, its kind ("error" | "info"), an optional second line and whether it
// offers an undo (the undo handler itself lives in actions/noticeActions.js).
export const initialNoticeState = { message: null, kind: "error", sub: null, canUndo: false };

export default function noticeReducer(state = initialNoticeState, action) {
  switch (action.type) {
    case types.NOTICE_SHOW:
      return { message: action.message, kind: action.kind, sub: action.sub || null, canUndo: Boolean(action.canUndo) };

    case types.NOTICE_CLEAR:
      return { ...state, message: null, sub: null, canUndo: false };

    default:
      return state;
  }
}
